import Vue from 'vue';

import createNotificationsRoutes from './router';
const isViewedEvent = Vue.observable({ event: false });

export { createNotificationsRoutes, isViewedEvent };



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/index.ts